var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.button)?_c('button',{attrs:{"href":_vm.route},on:{"click":function($event){$event.preventDefault();return _vm.emitRoot()}}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.route},on:{"click":function($event){$event.preventDefault();return _vm.emitRoot()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }